<!-- Button trigger modal -->
<button  [id]="'id_cerrar_'+info.nombre_modal" type="button" class="btn btn-primary" data-toggle="modal" [attr.data-target]="'#id_'+info.nombre_modal">
    Launch demo modal
  </button>
  
  <!-- Modal -->
  <div class="modal fade" [id]="'id_'+info.nombre_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{info.titulo}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>{{info.descripcion}}</p>
        </div>
        <div class="modal-footer">
          <button *ngIf="info.boton_cerrar" type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button *ngIf="info.boton_acepta" type="button" class="btn btn-primary">Save changes</button>
        </div>
      </div>
    </div>
  </div>